import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class VmPictureService {

  constructor(
    protected http: HttpClient) { }

  list(): Observable<any[]> {
    const api = '/machine-pictures';
    return this.http.get<any[]>(api);
  }

  create(name: string, importFile?: any): Observable<any> {
    const formData = new FormData();
    formData.append('name', name);
    if (importFile) {
      formData.append('picture', importFile);
    }
    return this.http.post('/machine-pictures', formData);
  }

  update(id: string, name: string, importFile?: any): Observable<any> {
    const formData = new FormData();
    formData.append('name', name);
    if (importFile) {
      formData.append('picture', importFile);
    }
    return this.http.put(`/machine-pictures/${id}`, formData);
  }
}
